function setMap(map) {
  return {
    type: 'SET_MAP',
    payload: map,
  };
}

export {
  setMap,
};